export const selectFilters = (state: Redux.State) =>
	state.search.filters.filters;
